import splitApi from "./emptySplitApi";

const utilityApi = splitApi.injectEndpoints({
  endpoints: (build) => ({
    getProtipManifest: build.query({
      query: ({ processDefKey = "", taskDefinitionKey = "" }) => ({
        url: `/api/protips/${processDefKey.toLowerCase()}/${taskDefinitionKey.toLowerCase()}/manifest`,
      }),
      providesTags: ["Protips"],
    }),
    getProtip: build.mutation({
      query: ({ market = "", processDefKey = "", protipId = "" }) => ({
        url: `/public/protips/${market.toLowerCase()}/${processDefKey.toLowerCase()}/${protipId}.json`,
      }),
      providesTags: ["Protips"],
    }),
    getProtipContent: build.query({
      query: ({ market = "", processDefKey = "", protipId = "" }) => ({
        url: `/public/protips/${market.toLowerCase()}/${processDefKey.toLowerCase()}/${protipId}.json`,
      }),
      providesTags: ["Protips"],
    }),
  }),
});
export const {
  useGetProtipManifestQuery,
  useGetProtipMutation,
  useGetProtipContentQuery,
} = utilityApi;
